import { ElementFactory } from "./ElementFactory";
import { ArrayElement } from "./ArrayElement";
/**
 * Array Element Factory
 */
export class ArrayElementFactory extends ElementFactory {
    /**
     * Creates element
     * @param htmlElement html element
     * @param bindData bind data
     * @param context context
     */
    createElement(htmlElement, bindData, context) {
        return new ArrayElement(htmlElement, bindData, context);
    }
}
//# sourceMappingURL=ArrayElementFactory.js.map